import {
    afterNextRender,
    Component,
    effect,
    inject,
    model,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { CenterRoleStore } from "../../../../../stores/center/role.store";

type Segment =
    | "sales"
    | "salary"
    | "session"
    | "treatment"
    | "child"
    | "counseling";

@Component({
    selector: "app-center-stat",
    templateUrl: "./center-stat.layout.html",
    imports: [CommonModule, RouterOutlet, RouterLink],
})
export default class CenterStatLayout {
    readonly router = inject(Router);
    readonly navigationEnd$ = injectNavigationEnd();
    readonly roleStore = inject(CenterRoleStore);

    readRole = this.roleStore.administrationRead;

    segmentOptions = [
        {
            label: "매출/매입",
            value: "sales",
            path: "/administration/center-stat/sales",
        },
        {
            label: "급여",
            value: "salary",
            path: "/administration/center-stat/salary",
        },
        {
            label: "회기",
            value: "session",
            path: "/administration/center-stat/session",
        },
        {
            label: "치료",
            value: "treatment",
            path: "/administration/center-stat/treatment",
        },
        {
            label: "상담",
            value: "counseling",
            path: "/administration/center-stat/counseling",
        },
        {
            label: "아동 상태",
            value: "child",
            path: "/administration/center-stat/child",
        },
    ];

    segment = model<Segment>("sales");
    constructor() {
        afterNextRender(() => {
            this.setSegment();
            this.navigationEnd$.subscribe({
                next: () => this.setSegment(),
            });
        });
    }

    setSegment() {
        const url = this.router.url;

        if (url.includes("sales")) {
            this.segment.set("sales");
        } else if (url.includes("salary")) {
            this.segment.set("salary");
        } else if (url.includes("session")) {
            this.segment.set("session");
        } else if (url.includes("treatment")) {
            this.segment.set("treatment");
        } else if (url.includes("child")) {
            this.segment.set("child");
        } else if (url.includes("counseling")) {
            this.segment.set("counseling");
        }
    }
}
